<template>
<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="收费明细" name="first" :lazy="true">
      <channel-free-statistics></channel-free-statistics>
    </el-tab-pane>
    <el-tab-pane label="收费设置" name="third">
        <private-used-car-config ref="private-used-car-config"></private-used-car-config>
    </el-tab-pane>
</el-tabs>
</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import FinalCenter from './FinalCenter'
import ChannelFreeStatistics from '@/pages/privateCar/ChannelFreeStatistics'
import privateUsedCarConfig from '@/pages/privateCar/privateUsedCarConfig'
export default {
  name: 'financial-tab-index',
  extends: BasicPager,
  data () {
    return {
      isAdmin: false,
      activeName: 'first'
    }
  },
  mounted: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath != 'channel'
  },
  components: {
    FinalCenter,
    ChannelFreeStatistics,
    privateUsedCarConfig
  },
  methods: {
    handleClick (tab, event) {
      let that = this
      switch (tab.name) {
        case 'third':
          that.$refs['private-used-car-config'].loadUsedCarConfigSourceData()
          break
        default:
      }

      console.log(tab, event)
    }
  }
}

</script>
